











import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import * as _ from "lodash";
import { inventoryCollection, optionsCollection } from "../db";
import * as firebase from "firebase/app";

@Component({})
export default class EquipmentOptionEdit extends Vue {
  @Getter options;

  get allOptions() {
    return this.options.map( x => x.name);
  }

  @Prop({ required: true })
  public item: any;

  async change(itemOptions) {
    await inventoryCollection.doc(this.item.id).update({
      options: itemOptions,
    });
  }
}
